import { PointsSettings } from "../../interfaces";
import { actionTypes } from "../_actions/points.action";

const initialState: PointsSettings = {
  isShowUltradePoints: null,
  discordEnabled: null,
  telegramEnabled: null,
  telegramBotName: "",
  telegramBotId: "",
  telegramGroupId:  "",
  telegramGroupName:  "",
  twitterEnabled:  null,
  twitterJobEnabled:  true,
  twitterAccountId:  "",
  twitterAccountName:  "",
  guideLink: "",
};

export const points = (state = initialState, action): PointsSettings => {
  switch (action.type) {
    case actionTypes.SAVE_POINTS_SETTINGS:
      return {
        ...state,
        ...action.data
      }
    case actionTypes.SHOW_POINTS_TAB:
      return {
        ...state,
        isShowUltradePoints: action.data
      }
    default:
      return state;
  }
};
